var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUidoLogoMenuHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9118 28.1554L19.0151 17.6842L15.6108 11.8445L9.50753 22.3157L3.40423 11.8445L0 17.6842L6.1033 28.1554H12.9118Z",
    fill: "#CC4429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5097 12.5251L12.9139 6.68415L9.5097 0.844482L6.10547 6.68415L9.5097 12.5251Z",
    fill: "#EFE8DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUidoLogoMenuHover);
export default __webpack_public_path__ + "static/media/uido_logo_menu_hover.a433136b74b98094cec4647fcc9456da.svg";
export { ForwardRef as ReactComponent };